import axios from "axios";
import {
  authDeviceWithDomainHeader,
  authWithDomainHeader,
} from "../authServices/auth.header";
import { setTimeConditions } from "@/helpers/BatchService.js";

const API_URL = process.env.VUE_APP_ROOT_API;
class TimeConService {
  // Get Time Condition List
  async getConList(filter = "", domain_uuid = null) {
    return await axios
      .get(API_URL + `call-app/time-condition` + filter, {
        headers: domain_uuid
          ? authWithDomainHeader(domain_uuid)
          : authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Time Condition Detail
  async getConDetails(dialplan_uuid) {
    return await axios
      .get(API_URL + `call-app/time-condition/${dialplan_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Add Time Condition
  async addCon(data) {
    return await axios
      .post(API_URL + `call-app/time-condition`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setTimeConditions();
        return response.data;
      });
  }

  // Edit Time Condition Detail
  async updateConDetails(dialplan_uuid, data) {
    return await axios
      .put(API_URL + `call-app/time-condition/${dialplan_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setTimeConditions();
        return response.data;
      });
  }
  // Edit Time Condition Detail
  async updateConStatus(dialplan_uuid, data) {
    return await axios
      .patch(API_URL + `call-app/time-condition/${dialplan_uuid}`, data, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //delete Time Condition Detail
  async deleteCon(dialplan_uuid) {
    return await axios
      .delete(API_URL + `call-app/time-condition/${dialplan_uuid}`, {
        headers: authDeviceWithDomainHeader(),
      })
      .then((response) => {
        setTimeConditions();
        return response.data;
      });
  }
}

export default new TimeConService();
